module.exports = __webpack_public_path__ + "static/media/verifikasi.68bf12fb.png";